import type { ReactElement } from "react";

export function NewCardIcon(): ReactElement {
  return (
    <svg
      width="42"
      height="28"
      viewBox="0 0 52 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="52" height="32.7826" rx="6" fill="#DAE0EB" />
      <path
        d="M25.1992 21.2916H26.8492V17.2416H30.8992V15.5916H26.8492V11.4916H25.1992V15.5916H21.0992V17.2416H25.1992V21.2916ZM26.0025 26.1916C24.6473 26.1916 23.3732 25.9344 22.1802 25.4201C20.9874 24.9057 19.9497 24.2077 19.0672 23.3261C18.1847 22.4444 17.4861 21.4076 16.9715 20.2156C16.4566 19.0237 16.1992 17.7501 16.1992 16.3948C16.1992 15.0355 16.4569 13.7574 16.9722 12.5606C17.4876 11.3639 18.1869 10.323 19.0702 9.4378C19.9536 8.55247 20.9904 7.8568 22.1807 7.3508C23.3709 6.84464 24.6426 6.59155 25.996 6.59155C27.3551 6.59155 28.6331 6.84439 29.8297 7.35005C31.0262 7.85572 32.0672 8.55089 32.9527 9.43555C33.8382 10.3202 34.534 11.3606 35.04 12.5566C35.5461 13.7526 35.7992 15.0305 35.7992 16.3903C35.7992 17.7501 35.5464 19.0237 35.0407 20.2111C34.5351 21.3982 33.84 22.4339 32.9555 23.3181C32.071 24.2022 31.0309 24.9022 29.8352 25.4181C28.6396 25.9337 27.362 26.1916 26.0025 26.1916ZM25.9992 24.5416C28.2744 24.5416 30.2016 23.7521 31.7807 22.1731C33.3597 20.5939 34.1492 18.6667 34.1492 16.3916C34.1492 14.1164 33.3597 12.1892 31.7807 10.6101C30.2016 9.03105 28.2744 8.24155 25.9992 8.24155C23.7241 8.24155 21.7969 9.03105 20.2177 10.6101C18.6387 12.1892 17.8492 14.1164 17.8492 16.3916C17.8492 18.6667 18.6387 20.5939 20.2177 22.1731C21.7969 23.7521 23.7241 24.5416 25.9992 24.5416Z"
        fill="#585B7A"
      />
    </svg>
  );
}
